import { HIDDEN_CHEST_RESPAWN_MS } from '../data/chests.js';
import { LOOT_POOLS, LOOT_PROFILES } from '../data/loot.js';
import { UPGRADE_MATERIALS } from '../data/upgrade-materials.js';
import { rollEquipment } from './loot.js';
export function chestState(view, now) {
    if (view.kind === 'camp') {
        if (view.campCleared !== true)
            return 'locked';
        if (view.openedAt !== undefined)
            return 'opened';
        // Cleared, but by others: it stays shut to someone who did not fight.
        return view.fought === true ? 'ready' : 'locked';
    }
    if (view.openedAt !== undefined && now - view.openedAt < HIDDEN_CHEST_RESPAWN_MS)
        return 'opened';
    // A cave's vault (ADR 0062): chained while a keeper stands, and only for
    // those who fought them; then once every four hours, as any hidden chest.
    if (view.campCleared !== undefined) {
        if (!view.campCleared || view.fought !== true)
            return 'locked';
    }
    return 'ready';
}
/** How often a chest holds a piece of equipment: a camp's is fought for. */
export const CHEST_PIECE_CHANCE = { camp: 0.35, hidden: 0.15 };
/** How often a camp's chest holds the biome's rare material. */
export const CAMP_RARE_CHANCE = 0.2;
/**
 * A guarded hidden chest, a cave's vault (ADR 0062): the longest walk and a
 * fight, at most once in four hours, so the best of the chests.
 */
export const VAULT_PIECE_CHANCE = 0.5;
export const VAULT_RARE_CHANCE = 0.35;
/**
 * What a chest holds: always one to three of the biome's common upgrade
 * material (two to four in a vault); now and then a piece of its equipment,
 * under the chest profile (common or rare); from a camp or a vault, now and
 * then its rare material. `guarded`: a hidden chest behind keepers.
 */
export function rollChest(biome, kind, rng, guarded = false) {
    const items = [];
    const materials = UPGRADE_MATERIALS[biome];
    const vault = kind === 'hidden' && guarded;
    items.push({
        templateId: materials.common.id,
        quantity: (vault ? 2 : 1) + Math.floor(rng() * 3),
    });
    if (rng() < (vault ? VAULT_PIECE_CHANCE : CHEST_PIECE_CHANCE[kind])) {
        const piece = rollEquipment(LOOT_PROFILES.chest, LOOT_POOLS[biome], rng);
        if (piece !== undefined)
            items.push({ templateId: piece.templateId, quantity: 1 });
    }
    const rare = vault ? VAULT_RARE_CHANCE : kind === 'camp' ? CAMP_RARE_CHANCE : 0;
    if (rare > 0 && rng() < rare)
        items.push({ templateId: materials.rare.id, quantity: 1 });
    return items;
}
/** Whether a player stands close enough to open it: touching, diagonals included. */
export function withinChestReach(player, chest, reach = 1) {
    return Math.max(Math.abs(player.x - chest.x), Math.abs(player.y - chest.y)) <= reach;
}
//# sourceMappingURL=chests.js.map